// ---------------------------------------------- modules import
import React, { ChangeEvent, FormEvent, FunctionComponent } from "react";
import { Link } from "react-router-dom";

import { IAddFormProps } from "./common";
import { useAuth, useAlbum } from "./hooks";
import { ThemeContext } from "../../../contexts/themeContext";
import PermissionHelper from "../../../store/helpers/permissionHelper";
import { pattern } from "../../../store/helpers/validationHelper";

// ---------------------------------------------- the component
const AddForm: FunctionComponent<IAddFormProps> = ({ menuIndex }) => {
  // ---------------------------------------------- local state
  const { auth, profile } = useAuth();
  const { isAlbumValid, onChange, onAdd } = useAlbum(menuIndex);

  // ---------------------------------------------- handlers
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => onChange(e.currentTarget.name, e.currentTarget.value);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    onAdd(auth, profile, `/${PermissionHelper.getUrl(menuIndex)}`);
  };

  // ---------------------------------------------- content
  return profile ? (
    <ThemeContext.Consumer>
      {({ theme }) => (
        <div className="container row">
          <form className="card col s12 m10 offset-m1" onSubmit={handleSubmit}>
            <div
              className="card-content row"
              style={{ marginBottom: "0px", paddingBottom: "0px" }}
            >
              <span style={{ fontSize: "0.75rem" }}>
                {PermissionHelper.getName(menuIndex).toLowerCase()}
              </span>

              <span className="card-title" style={{ marginBottom: "20px" }}>
                ADD FORM
              </span>

              <div className="input-field col s12 m6">
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="validate"
                  pattern={pattern.album.name.toString().slice(1, -1)}
                  minLength={2}
                  maxLength={50}
                  onChange={handleChange}
                  required
                />

                <label htmlFor="name">Name</label>
              </div>

              <div className="input-field col s12 m6">
                <textarea
                  id="link"
                  name="link"
                  className="materialize-textarea"
                  maxLength={200}
                  onChange={handleChange}
                />

                <label htmlFor="link">Album Link</label>
              </div>
            </div>

            <div className="card-action row" style={{ marginBottom: "0" }}>
              <div className="col s6">
                <Link
                  to={`/${PermissionHelper.getUrl(menuIndex)}`}
                  className="btn-floating btn-small waves-effect waves-light"
                  style={{ backgroundColor: theme.ui }}
                >
                  <i className="material-icons left">arrow_back</i>
                </Link>
              </div>

              <div className="col s6 right-align">
                <button
                  type="submit"
                  className={`btn-small waves-effect waves-light ${
                    isAlbumValid() ? "" : "disabled"
                  }`}
                  style={{ backgroundColor: theme.ui }}
                >
                  Submit<i className="material-icons right">send</i>
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
    </ThemeContext.Consumer>
  ) : null;
};

export default AddForm;
